export default __webpack_public_path__ + "static/media/Ask_Ai_Icon.49c47f3b.svg";